import { toast } from 'react-toastify'
import logger from '@/lib/logger'
import { useContext } from 'react'
import ProfileContext from '@/components/Context/ProfileContext'
import { gaAddToCart } from '@/lib/googleAnalytics/actions'
import {
  addProductsBasket as addProductsBasketLib,
  ProductAddBasketResponse,
} from '@/lib/basket/addProductsBasket'

const useAddProductBasket = () => {
  const { basketAllRefetcher, basket } = useContext(ProfileContext)

  // Retourne la quantité actuellement dans le panier pour un produit donné
  const getCartQuantity = (productId: string): number => {
    if (!basket?.product_groups) return 0
    for (const group of basket.product_groups) {
      const found = group?.products?.find(p => p?.product_id === productId)
      if (found) return Number(found.amount) || 0
    }
    return 0
  }

  const addProductToBasket = async products => {
    if (products.length) {
      const productsWithCartAmount = products.map(product => ({
        ...product,
        current_cart_amount: getCartQuantity(String(product.product_id)),
      }))

      await addProductsBasketLib(productsWithCartAmount)
        .then((response: ProductAddBasketResponse[]) => {
          const haveAtLeastOneFail = response.some(i => !i.available)

          if (haveAtLeastOneFail) {
            response.forEach(p => {
              if (!p.available) {
                if (p.available_amount != null) {
                  if (p.available_amount <= 0) {
                    toast.error(`Stock épuisé pour : ${p.product}`)
                  } else {
                    toast.error(
                      `Seulement ${p.available_amount} disponible${p.available_amount > 1 ? 's' : ''} pour : ${p.product}`
                    )
                  }
                } else {
                  toast.error(`Produit indisponible : ${p.product}`)
                }
              } else {
                toast.success(`Produit ajouté au panier : ${p.product}`)
              }
            })
          } else {
            if (products.length === 1) {
              const [productInfo] = products
              const label = productInfo.product || 'Produit'
              toast.success(`${productInfo.amount} × ${label} — Produit ajouté au panier`)
            } else {
              const summary = products
                .map(product => {
                  const label = product.product || 'Produit'
                  return `${product.amount}× ${label}`
                })
                .join(' • ')
              toast.success(`Les produits ont bien été ajoutés à votre panier — ${summary}`)
            }
            products.forEach(product => {
              gaAddToCart(product, product.amount)
            })
          }

          // Refetch dans TOUS les cas (y compris echec partiel) : CS-Cart peut
          // avoir applique une partie de l'ajout (stock limite, produit deja au
          // panier plafonne) — sans refetch l'affichage du panier reste perime.
          return basketAllRefetcher()
        })
        .catch(logger.error)
    } else {
      toast.info("Aucun produit disponible n'a été ajouté au panier")
    }
  }

  return {
    addProductToBasket,
  }
}

export default useAddProductBasket
